'use strict';

/**
 * Sentry factory.
 * Expose Sentry as an angular DI object.
 */
customerZone.factory('Sentry', [function(){
    return window.Sentry || {
        addBreadcrumb: function(){},
        captureMessage: function(){},
        captureException: function(){},
        setUser: function(){},
        setExtra: function(){},
        setTags: function(){},
    };
}]);
